var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgFullscreenexit(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M4.75781 11.1875H9.99609C10.6729 11.1875 11.0684 10.792 11.0684 10.1152V4.87695C11.0684 4.53418 10.8223 4.25293 10.4619 4.25293C10.1016 4.25293 9.85547 4.5166 9.85547 4.87695V6.34473L9.99609 9.31543L7.33301 6.57324L4.49414 3.70801C4.37988 3.58496 4.23047 3.53223 4.06348 3.53223C3.68555 3.53223 3.41309 3.77832 3.41309 4.15625C3.41309 4.32324 3.47461 4.49023 3.59766 4.60449L6.46289 7.47852L9.19629 10.1152L6.2168 9.97461H4.75781C4.40625 9.97461 4.13379 10.2207 4.125 10.5811C4.125 10.9414 4.39746 11.1875 4.75781 11.1875ZM13.415 20.3369C13.7666 20.3369 14.0215 20.0732 14.0215 19.7129V18.0342L13.8809 15.0635L16.5352 17.7969L19.5146 20.7939C19.6289 20.917 19.7783 20.9785 19.9365 20.9785C20.3145 20.9785 20.5869 20.7324 20.5869 20.3545C20.5869 20.1787 20.5254 20.0205 20.4111 19.8975L17.4141 16.9004L14.6719 14.2549L17.6514 14.4043H19.3301C19.6816 14.4043 19.9541 14.1582 19.9629 13.7979C19.9629 13.4375 19.6904 13.1826 19.3301 13.1826H13.8809C13.2041 13.1826 12.7998 13.5869 12.7998 14.2637V19.7129C12.7998 20.0645 13.0547 20.3369 13.415 20.3369Z",
    fill: "currentcolor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFullscreenexit);
export default __webpack_public_path__ + "static/media/Fullscreen exit.7a3d2e5b8100767c517eec3c1a0b1b2e.svg";
export { ForwardRef as ReactComponent };